import React, { useEffect, useState } from 'react';
import { ppuApi } from '../api';
import { Facility } from '../api_types';
import { Link } from 'react-router-dom';

const PPUFacilitiesList: React.FC = () => {
  const [facilities, setFacilities] = useState<Facility[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchFacilities = async () => {
      try {
        const ppuFacilities = await ppuApi.getPPUFacilities();
        setFacilities(ppuFacilities);
      } catch (err) {
        setError('Failed to load facilities');
      } finally {
        setLoading(false);
      }
    };
    fetchFacilities();
  }, []);

  if (loading) return <div className="p-8 text-center">Loading...</div>;
  if (error) return <div className="p-8 text-center text-red-600">{error}</div>;

  return (
    <div className="max-w-2xl mx-auto p-8">
      <h1 className="text-2xl font-bold mb-6">Pay-Per-Use Facilities</h1>
      {facilities.length === 0 ? (
        <div className="text-gray-600">No Pay-Per-Use facilities available at this time.</div>
      ) : (
        <ul className="space-y-4">
          {facilities.map(facility => (
            <li key={facility.id} className="bg-white shadow rounded p-4 flex items-center justify-between">
              <div>
                <div className="font-semibold text-lg">{facility.name}</div>
                <div className="text-gray-500 text-sm">{facility.address}</div>
              </div>
              <Link
                to={`/member/register?businessId=${facility.business_id}&facilityId=${facility.id}&ppu=1`}
                className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
              >
                Sign Up
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default PPUFacilitiesList; 